export default (url) => {
  return new Promise((resolve, reject) => {
    // check if the script loaded before
    const scripts = document.querySelectorAll(`script[src='${url}']`)
    if (scripts.length) {
      // the script loaded before so we just return
      return resolve()
    }

    // start loading
    const remoteScript = document.createElement('script')
    remoteScript.type = 'text/javascript'
    remoteScript.onload = function () {
      return resolve()
    }
    remoteScript.onerror = function () {
      return reject()
    }
    remoteScript.src = url
    document.getElementsByTagName('head')[0].appendChild(remoteScript)
  })
}
